const mutations = {
  setFnds(state, payload) {
      state.fnds = payload;
  },
  setOrganizations(state, payload) {
      state.organizations = payload;
  },
  /**
   * Search for FND by ID and add specified user to it
   * @param {import('./state').State} state
   * @param {[Number, import('@/store/users/state').User]} payload
   */
  addUserToFnd(state, payload) {
    const [fndID, user] = payload;
    const fndArrayIndex = state.fnds.findIndex(item => item.id === fndID);
    state.fnds[fndArrayIndex].employees.data.unshift(user);
  },
  /**
   * Search for FND by ID and delete specified user from it
   * @param {import('./state').State} state
   * @param {[Number, Number]} payload
   */
  deleteUserFromFnd(state, payload) {
    const [fndID, userID] = payload;
    const fndArrayIndex = state.fnds.findIndex(item => item.id === fndID);
    state.fnds[fndArrayIndex].employees.data = state.fnds[fndArrayIndex].employees.data.filter(item => item.id !== userID);
  },
};

export default mutations;
